// extracted by mini-css-extract-plugin
module.exports = {"button":"Button2_button__3tZcl","outline":"Button2_outline__ex9X_","inline":"Button2_inline__H9NxX"};